import {ErrorHandler, Injectable} from '@angular/core';
import {NotificationService} from '@proleis/proleis-web-app';
import {HttpErrorResponse} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SuppliersErrorHandler implements ErrorHandler {

  constructor(private ns: NotificationService) {
  }

  handleError(errorEvent: any) {
    if (errorEvent instanceof HttpErrorResponse) {
      this.handleHttpError(errorEvent);
    }

    if (errorEvent instanceof Error) {
      if (!errorEvent.message) {
        errorEvent.message = 'ERROR';
      }
      this.ns.showError(errorEvent);
    }
  }

  private handleHttpError(errorEvent: HttpErrorResponse) {
    if (errorEvent.error?.message) {
      this.ns.showError(new Error(errorEvent.error.message));
    } else {
      this.ns.showError(new Error(`HTTP Error ${errorEvent.status} - ${errorEvent.statusText} - ${errorEvent.url.substring(0, 100)} `));
    }
  }
}
